<template>
  <v-dialog
    v-model="dialog"
    width="500px"
    style="z-index: 9999;"
  >
    <v-card>
      <v-toolbar dense elevation="0">
        <v-toolbar-title>{{ $t("dialog.groupset_selection.title") }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-text-field
          :label="$t('dialog.company_selection.filter')"
          v-model="filter"
          solo
          flat
          autofocus
          hide-details
          prepend-inner-icon="mdi-filter"
          style="width: 40px"
        ></v-text-field>
        <v-btn icon @click="dialog=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider class="mx-2" />

      <v-virtual-scroll ref="vscroll" :items="filteredGroupsets" bench="64" min-height="104px" max-height="50vh"
                        item-height="54">
        <template v-slot:default="{ item }">
          <v-list-item :key="item.companyId" @click="groupsetSelect(item)">
            <v-list-item-icon>
              <v-icon v-if="item.groupSetId === null">group_work</v-icon>
              <v-icon v-else>workspaces</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}<span class="grey--text" v-if="item.note !== null">&nbsp;&nbsp;•&nbsp;&nbsp;{{ item.note
                }}</span></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-virtual-scroll>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "GroupsetSelectionDialog",

  data() {
    return {
      dialog: false,
      filter: null,
      items: []
    };
  },

  methods: {
    open() {
      this.filter = null;
      this.dialog = true;
      this.items = [];

      this.$store.dispatch("groupsets/fetchGroupsets")
        .then(result => {
          this.items = [{
            groupSetId: null,
            name: this.$t("dialog.groupset_selection.view_all"),
            note: null
          }, ...result.data];
        });

      let refs = this.$refs;
      this.$nextTick().then(() => {
        refs.vscroll.$el.scrollTop = 1;
        refs.vscroll.$el.scrollTop = 0;
      });
    },

    groupsetSelect(item) {
      this.$store.dispatch("groupsets/setGroupset", item.groupSetId);
      this.dialog = false;
    },

    keyEvent(keyEvent) {
      if (!this.dialog)
        return;

      if (keyEvent.key === "Enter") {
        const groupsets = this.filteredGroupsets
        if (groupsets.length === 1)
          this.groupsetSelect(groupsets[0]);
      }
    }
  },

  watch: {
    dialog(newValue) {
      if (newValue === false)
        this.$store.dispatch("dialogs/hideDialog", "groupsetSelection");
    }
  },

  computed: {
    filteredGroupsets() {
      if (this.filter != null)
        return this.items.filter(
          x => x.name.toLowerCase().includes(this.filter.toLowerCase()));
      else
        return this.items;
    }
  },

  mounted() {
    document.addEventListener("keydown", this.keyEvent);
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.keyEvent);
  }
};
</script>